import React from 'react';

export function getWidgetTitle(key: string): string {
  switch (key) {
    case 'warnings':
      return 'Warnings';
    case 'citations':
      return 'Citations';
    case 'arrests':
      return 'Arrests';
    case 'time_spent':
      return 'Time Spent';
    case 'reports':
      return 'Reports';
    case 'initiatives':
      return 'Total Initiatives';
    default:
      return key;
  }
}

export function getWidgetOrder(key: string): number {
  switch (key) {
    case 'initiatives':
      return 0;
    case 'reports':
      return 1;
    case 'warnings':
      return 2;
    case 'citations':
      return 3;
    case 'arrests':
      return 4;
    case 'time_spent':
      return 5;
    default:
      return -1;
  }
}

export function durationTimeFormat(duration: string | number): string {
  const totalMinutes = Number(duration);

  if (!Number.isFinite(totalMinutes) || totalMinutes < 0) {
    return '';
  }

  const roundedMinutes = Math.round(totalMinutes);

  if (roundedMinutes <= 60) {
    return `${roundedMinutes}m`;
  }

  const minutesInHour = 60;
  const minutesInDay = 1440;

  if (roundedMinutes < minutesInDay) {
    const hours = Math.floor(roundedMinutes / minutesInHour);
    const minutes = roundedMinutes % minutesInHour;
    return minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`;
  }

  const days = Math.floor(roundedMinutes / minutesInDay);
  const remainingHours = Math.floor(
    (roundedMinutes % minutesInDay) / minutesInHour
  );
  return remainingHours === 0 ? `${days}d` : `${days}d ${remainingHours}h`;
}

export function durationTimeFormatStyled(
  duration: string | number
): React.ReactElement {
  const formatted = durationTimeFormat(duration);

  if (!formatted) {
    return React.createElement(React.Fragment, null, '');
  }

  const unitStyle: React.CSSProperties = {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '24px'
  };
  const parts: React.ReactNode[] = [];
  const regex = /(\d+)([dhm])/g;

  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(formatted)) !== null) {
    if (match.index > lastIndex) {
      parts.push(formatted.slice(lastIndex, match.index));
    }

    parts.push(
      React.createElement(
        'span',
        { key: match.index },
        match[1],
        React.createElement('span', { style: unitStyle }, match[2])
      )
    );

    lastIndex = regex.lastIndex;
  }

  if (lastIndex < formatted.length) {
    parts.push(formatted.slice(lastIndex));
  }

  return React.createElement(React.Fragment, null, ...parts);
}
